// extracted by mini-css-extract-plugin
export var label = "_bq-2";
export var slideContainer = "_bq-0";
export var slider = "_bq-1";